var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "failed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "failed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0 C10.8659932,0 14,3.13400675 14,7 C14,10.8659932 10.8659932,14 7,14 C3.13400675,14 0,10.8659932 0,7 C0,3.13400675 3.13400675,0 7,0 Z M9.47487373,3.64517116 L6.99917116,6.12017116 L4.52512627,3.64517116 L3.64517116,4.52512627 L6.12017116,6.99917116 L3.64517116,9.47487373 L4.52512627,10.3548288 L6.99917116,7.87917116 L9.47487373,10.3548288 L10.3548288,9.47487373 L7.87917116,6.99917116 L10.3548288,4.52512627 L9.47487373,3.64517116 Z",
    fill: "#F63D3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedCircle);
export default __webpack_public_path__ + "static/media/failed-circle.61a636cc894bbe918b1a7c44b2a3ada1.svg";
export { ForwardRef as ReactComponent };